import { render, staticRenderFns } from "./Singlecard.vue?vue&type=template&id=ce076b28&scoped=true"
import script from "./Singlecard.vue?vue&type=script&lang=js"
export * from "./Singlecard.vue?vue&type=script&lang=js"
import style0 from "./Singlecard.vue?vue&type=style&index=0&id=ce076b28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce076b28",
  null
  
)

export default component.exports